function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 28.7031,
  y: 25.6719,
  width: 116.701,
  height: 119.573,
  rx: 58.3504,
  fill: "#EFEFEF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 38.1328,
  y: 35.334,
  width: 97.84,
  height: 100.248,
  rx: 48.92,
  fill: "#A3A3A3"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.021 108.725C164.221 108.854 165.093 109.956 164.967 111.185C164.842 112.414 163.766 113.308 162.566 113.179C161.367 113.051 160.495 111.948 160.62 110.719C160.746 109.49 161.822 108.597 163.021 108.725Z",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.6171
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.8594 154.084C43.832 154.296 45.266 156.109 45.0596 158.13C44.8531 160.151 43.0839 161.62 41.1113 161.409C39.1386 161.197 37.7046 159.385 37.9111 157.363C38.1175 155.342 39.8868 153.873 41.8594 154.084Z",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 2.65921
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85.8633 3.41842C87.8359 3.62995 89.2699 5.44272 89.0635 7.46389C88.857 9.48506 87.0878 10.9543 85.1152 10.7428C83.1426 10.5313 81.7086 8.71852 81.915 6.69735C82.1214 4.67619 83.8907 3.2069 85.8633 3.41842Z",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 2.65921
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.6418 51.3711C3.54792 51.3711 4.28361 52.1249 4.28361 53.0533C4.28361 53.9817 3.54792 54.7355 2.6418 54.7355C1.73569 54.7355 1 53.9817 1 53.0533C1 52.1249 1.73569 51.3711 2.6418 51.3711Z",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.94378
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.157 161.072C131.064 161.072 131.799 161.826 131.799 162.754C131.799 163.683 131.064 164.437 130.157 164.437C129.251 164.437 128.516 163.683 128.516 162.754C128.516 161.826 129.251 161.072 130.157 161.072Z",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.94378
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.93 44.5586L156.858 38.1021",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.13254
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.852 40.3887L159.153 42.3645",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.13254
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.27344 113.115L10.9744 106.592",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.13254
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.04297 109.025L13.4095 110.768",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.13254
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.254 142.328L147.605 135.719",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.13254
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M143.809 138.369L150.259 139.753",
  stroke: "#151515",
  strokeOpacity: 0.2,
  strokeWidth: 1.13254
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62.644 61.1426H45.8867V113.073H62.644V61.1426Z",
  fill: "#CECECE"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85.2143 56.4238H68.457V113.038H85.2143V56.4238Z",
  fill: "#CECECE"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.773 70.002H91.0156V113.073H107.773V70.002Z",
  fill: "#CECECE"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.339 49.0977H113.582V113.074H130.339V49.0977Z",
  fill: "#CECECE"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.6523 113.074H135.941",
  stroke: "#858585",
  strokeWidth: 1.71856,
  strokeMiterlimit: 10
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.7266 124.589C82.0871 124.29 83.4475 124.323 84.808 124.589C83.4475 124.589 82.0871 124.589 80.7266 124.589Z",
  fill: "#F3DB5D"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.3867 124.589C90.6808 124.323 92.0082 124.29 93.3023 124.589C92.0082 124.589 90.714 124.589 89.3867 124.589Z",
  fill: "#F3DB5C"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.3181 86.7598C75.2185 86.9589 75.0526 86.9257 74.8867 86.9257C74.9863 86.7929 75.1522 86.7929 75.3181 86.7598Z",
  fill: "#463F44"
});

var SvgEmptyBarchart = function SvgEmptyBarchart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmptyBarchart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-barchart.5c5d3589.svg";
export { ForwardRef as ReactComponent };